import React from 'react';

const NavigationDots = ({ active }) => {
	const navigationArray = [
		'Home',
		'Skills',
		'Projects',
		'Contact',
		// 'About',
		// 'Testimonial',
	];

	return (
		<div className='app__navigation'>
			{navigationArray.map((item, index) => (
				// eslint-disable-next-line jsx-a11y/anchor-has-content
				<a
					href={`#${item}`}
					key={item + index}
					className='app__navigation-dot'
					// onClick={() => setToggle(false)}
					style={active === item ? { backgroundColor: '#313BAC' } : {}}
				/>
			))}
		</div>
	);
};

export default NavigationDots;
